'use strict'

module.exports =  window.location.href.includes('localhost') || window.location.href.includes('test')  ? require('./env.config') : require('./production.config')



// WEBPACK FOOTER //
// ./src/config/index.js